export const zindex = {
  modal: 200, // A modal overlay should cover everything, except it's own content
  menu: {
    header: 107,
    searchSuggestions: 110,
    searchOverlay: 100,
    searchBar: 120,
    left: 105,
    sticky: {
      normal: 10,
      background: {
        default: 99,
        isSticky: 102,
      },
    },
    filter: 107,
    experimentEditor: 101,
    mega: 107,
    mobile: { overlay: 108, content: 109 },
  },
  overlay: 106, // An overlay should not cover to navigation, but all the rest of the page, but be below whatever it opens
  ads: {
    outside: 100,
  },
  graph: 99,
  popover: 4,
};
